module.exports = __webpack_public_path__ + "static/media/btn_google_signin.9523da15.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/btn_google_signin.png
 ** module id = 695
 ** module chunks = 0
 **/